<template>
  <div class="ui-edit-layout">
    <div class="ui-edit-layout-panel">
      <div class="ui-edit-layout-tools" :class="{ minimized: minimized }">
        <div
          class="expands is-hidden-mobile"
          @click="minimized = false"
          v-show="minimized"
        >
          <span class="border"></span>
        </div>
        <slot name="tools"></slot>
        <div
          class="minimize is-hidden-mobile"
          @click="minimized = true"
          v-show="!minimized"
        >
          <span class="border"></span>
        </div>
      </div>
      <main class="ui-edit-layout-main">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script lang="ts" setup>
const minimized: Ref<boolean> = ref(false)
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.ui-edit-layout {
  border-top-left-radius: 6px;
  background-color: $white;
  border-top: $basic-border;
  border-left: $basic-border;
  overflow: hidden;
  @include is-mobile() {
    border-radius: 0;
    border: none;
  }
  .ui-edit-layout-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
    .ui-edit-layout-tools {
      min-height: 3rem;
      position: relative;
      padding: 0 calc(3rem - 6px);
      display: flex;
      align-items: center;
      gap: 12px;
      border-bottom: $basic-border;
      width: 100%;
      background-color: $white;
      button,
      a {
        .jps-icon {
          font-size: 1rem;
        }
        @include no-decorative-button;
        font-size: 0.75rem;
        color: $jps-gray-800;
        display: flex;
        align-items: center;
        gap: 3px;
        padding: 6px;
        border-radius: 6px;
        transition: all $transition-timing;
        &.is-primary {
          color: $jps-key-blue;
          font-weight: bold;

          @include is-tablet {
            margin: 0 0 0 auto;
          }
        }
        &:disabled {
          cursor: default;
          color: $jps-gray-500;
        }
        &:not(:disabled):hover {
          box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
        }
        &.is-right {
          margin-left: auto;
        }
      }
      @include is-mobile() {
        overflow-x: auto;
        padding: 0 1rem;
        button,
        a {
          .jps-icon {
            font-size: 1.5rem;
          }
          flex-shrink: 0;
          &.is-primary {
            order: -1;
          }
        }
      }
      &.minimized {
        padding-left: 1rem;
        padding-right: 1rem;
        position: absolute;
        z-index: 1000;
        top: 0;
        right: 0;
        border-top: $basic-border;
        border-left: $basic-border;
        border-bottom-left-radius: 6px;
        width: fit-content;
        .el-label {
          display: none;
        }
        button,
        a {
          &.is-right {
            margin-left: 0;
          }
        }
      }
      .expands,
      .minimize {
        @include no-decorative-button();
        position: absolute;
        height: 3rem;
        width: 1rem;
        transition: $transition;
        cursor: pointer;

        .border {
          display: none;
          height: 1rem;
          width: 1.5px;
          top: 1rem;
          background-color: $jps-gray-500;
          position: absolute;
        }
        &:hover {
          .border {
            display: block;
          }
        }
      }
      .expands {
        left: 0;
        .border {
          right: 0;
        }
      }
      .minimize {
        right: 0;
        .border {
          left: 0;
        }
      }
    }
    .ui-edit-layout-main {
      overflow-y: auto;
      flex-grow: 1;
    }
  }
}
</style>
